import { Box, Stack } from "@mui/material";
import { useLocation, useNavigate } from "react-router-dom";
import confirmMail from "../../assets/images/icons/verifyMail.svg";
import Button from "../../components/ui/Button";
import Text from "../../components/ui/Text";

const ForgotPasswordCheckEmail = () => {
  const navigate = useNavigate();
  const location = useLocation();

  // Get email from navigation state
  const email = location.state?.email || "your email";

  const handleBackToSignin = () => {
    navigate("/signin");
  };

  const handleResendEmail = () => {
    // In a real app, this would trigger another API call
    // You could show a toast notification here
  };

  return (
    <>
      {/* Welcome Section */}
      <Box sx={{ mb: 3 }}>
        <Text variant="pageHeader" sx={{ mb: "8px !important" }}>
          Check your email
        </Text>
        <Text
          variant="paragraph3"
          sx={{
            fontSize: "16px",
            color: "#666666",
          }}
        >
          We sent a password reset link to{" "}
          <Text
            component="span"
            variant="paragraph3"
            sx={{
              fontWeight: 600,
              fontSize: "16px",
              color: "#000000",
            }}
          >
            {email}
          </Text>
        </Text>
      </Box>

      {/* Email Icon - Centered */}
      <Box sx={{ textAlign: "center", mb: 4 }}>
        <Box
          component="img"
          src={confirmMail}
          alt="Check your email"
          sx={{
            width: "120px",
            height: "auto",
          }}
        />
      </Box>

      <Stack spacing={3}>
        {/* Simulate Email Link - For testing purposes */}
        <Button
          variant="primary"
          onClick={() => navigate("/create-new-password", { state: { email } })}
          sx={{ mt: 3 }}
        >
          Continue (Simulate Email Link)
        </Button>

        {/* Back to Sign In Button */}
        <Button variant="secondary" onClick={handleBackToSignin}>
          Back to Sign In
        </Button>

        {/* Resend link */}
        <Box sx={{ textAlign: "center" }}>
          <Text
            variant="paragraph3"
            sx={{
              color: "#1890FF",
              cursor: "pointer",
              textDecoration: "underline",
            }}
            onClick={handleResendEmail}
          >
            Didn't receive the email? Resend
          </Text>
        </Box>
      </Stack>
    </>
  );
};

export default ForgotPasswordCheckEmail;
